import styled from 'styled-components';

export const HiddenTable = styled.div`
  display: none;
`;
export const ExcelContainer = styled.div`
  display: flex;
  padding: 10px 20px;
  justify-content: flex-end;
  border: none;
  & button {
    padding: 5px;
    background-color: #1d6f42;
    border: none;
    color: white;
    font-weight: 550;
    border-radius: 5px;
    cursor: pointer;
  }
`;
